import React from "react"
import HeaderCTA from "../components/HeaderCTA"
import { Helmet } from "react-helmet"

export default () => (
  <>
    <Helmet
      htmlAttributes={{
        lang: "pl",
      }}
      title={
        "Korzyści z przejścia do chmury Azure - case study - SITA FOR AIRCRAFT"
      }
      meta={[
        {
          property: `og:title`,
          content:
            "Korzyści z przejścia do chmury Azure - case study - SITA FOR AIRCRAFT",
        },
      ]}
    />
    <HeaderCTA />
  </>
)
